import type { App } from 'vue'
import { inject } from 'vue'

const key = 'app.plugin.googleSignInId'

type IdType = string | undefined

export function provideGoogleSignInId(app: App, id: IdType): void {
    app.provide(key, id)
}

export function useGoogleSignInId(): IdType {
    return inject(key) as IdType
}
